import { useAuthenticator, WithAuthenticatorProps, Button, Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe, ArrowRight, Check, Menu, X } from 'lucide-react';


const TranslationNavBarComponent = () => {
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleSignOut = async () => {
        await signOut();
        navigate("/");
    };

    const handleSignInClick = () => {

    };

    return (
        <>
            <header className="header">
                <div className="header-content">
                    <div className="logo">
                        <span className="logo-text">Certified International Translations Inc</span>
                    </div>
                    <nav className="desktop-nav">
                        <ul>
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Services</a></li>
                            {user ? (
                                <>
                                    <li><a href="/translations/myrequests">Translations</a></li>
                                    <li><a href="#" onClick={handleSignOut}>Sign Out</a></li>
                                </>
                            ) : (
                                <>
                                    <li><a href="#">About</a></li>
                                    <li><a href="#">Contact</a></li>
                                    <li><a href="/signin">Sign In</a></li>
                                </>
                            )}
                        </ul>
                    </nav>
                    <button
                        className="mobile-menu-button"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        {mobileMenuOpen ? <X /> : <Menu />}
                    </button>
                </div>
                {
                    mobileMenuOpen && (
                        <nav className="mobile-nav">
                            <ul>
                                <li><a href="#">Home</a></li>
                                <li><a href="#">Services</a></li>
                                {user ? (
                                    <>
                                        <li><a href="#">My Translations</a></li>
                                        <li><a href="#" onClick={handleSignOut}>Sign Out</a></li>
                                    </>
                                ) : (
                                    <>
                                        <li><a href="#">About</a></li>
                                        <li><a href="#">Contact</a></li>
                                        <li><a href="/signin">Sign In</a></li>
                                    </>
                                )}
                            </ul>
                        </nav>
                    )
                }
            </header >
        </>
    )
};

export default TranslationNavBarComponent;